// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"d239c25a","659":"bedca7ae"}[chunkId] + ".chunk.js";
};